<template>
  <div class="notifications-bar warning" v-if="showStatusBar && content">
    <img class="inline-block notifications-icon" :src="content.icon" alt="warning-icon">

    <span>
      {{ content.message }}
    </span>

  </div>
</template>

<script>
export default {
  name: 'MaintenanceNotification',
  computed: {
    content () {
      if (!this.showStatusBar) {
        return null
      }
      return {
        message: this.$t('Maintenance Notification'),
        icon: require('@/assets/images/status-bar/warning.svg')
      }

    },

    showStatusBar () {
      return (process.env.VUE_APP_SHOW_MAINTENANCE_NOTIFICATION === 'true') || false
    }
  }
}
</script>

<style lang="scss" scoped>
  .notifications-bar {
    color: rgba(0, 0, 0, 0.65);
    border-radius: 0.5rem;
    text-align: left;
    padding: 15px 20px;
    margin-bottom: 30px;
  }

  .warning {
    border: 1px solid #f2af03;
    background-color: #f9f4e7;
  }

  .notifications-icon {
    position: relative;
    top: 5px;
    margin-right: 12px;
  }
</style>
